import { render, staticRenderFns } from "./DelRoute.vue?vue&type=template&id=086571fa&scoped=true"
import script from "./DelRoute.vue?vue&type=script&lang=js"
export * from "./DelRoute.vue?vue&type=script&lang=js"
import style0 from "./DelRoute.vue?vue&type=style&index=0&id=086571fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086571fa",
  null
  
)

export default component.exports